import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";
import Loader from "../../components/Loader";

function KittyBooking() {
    const { id } = useParams();

    const [kitty, setKitty] = useState(null);
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadBookingData();
    }, [id]);

    const loadBookingData = async () => {
        try {
            setLoading(true);
            const res = await api.get(`/kittybookingdata/${id}`);

            setKitty(res.data.kitty);
            setBookings(res.data.bookings || []);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch booking details");
        } finally {
            setLoading(false);
        }
    };

    // ✅ SAFETY CHECK
    if (loading || !kitty) return <Loader />;
    if (error) return <p className="text-red-500 p-6">{error}</p>;

    const totalTokens = Number(kitty.number_of_tokens || 0);

    return (
        <div className="p-6">
            <h2 className="text-xl font-semibold mb-2 text-center">
                {kitty.kitty_name}
            </h2>

            <p className="text-center text-gray-500 mb-6">
                Total Tokens: {totalTokens}
            </p>

            {/* Token Grid */}
            <div className="bg-white shadow rounded-2xl p-6">
                <div className="grid grid-cols-5 gap-4 justify-items-center">
                    {Array.from({ length: totalTokens }, (_, i) => {
                        const tokenNo = i + 1;

                        const bookedToken = bookings.find(
                            b => Number(b.token_number) === tokenNo
                        );

                        return (
                            <div key={tokenNo} className="text-center">
                                <div
                                    className={`w-12 h-12 rounded-lg flex items-center justify-center text-sm font-semibold
                                    ${
                                        bookedToken
                                            ? "bg-red-500 text-white cursor-not-allowed"
                                            : "border border-gray-500 hover:bg-black hover:text-white cursor-pointer"
                                    }`}
                                >
                                    {tokenNo}
                                </div>

                                {bookedToken && (
                                    <div className="text-xs mt-1 font-medium text-center">
                                        {bookedToken.full_name}
                                        <br />
                                        <span className="text-gray-500 text-[10px]">
                                            {bookedToken.customer_mobile}
                                        </span>
                                    </div>
                                )}

                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default KittyBooking;
